define(["require", "exports", "tslib", "mobx", "mobx-react", "react", "../../utils/Environment", "./index"], function (require, exports, tslib_1, mobx_1, mobx_react_1, React, Environment_1, index_1) {
    "use strict";
    var NumberField_1;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NumberField = void 0;
    React = tslib_1.__importStar(React);
    let NumberField = exports.NumberField = NumberField_1 = class NumberField extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "min", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "max", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isNumberRegexPattern", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isNumberRegex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "precision", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onChangeObserver", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "observedObject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "value", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "valueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.required = props.propertyOwner.constructor[props.propertyName + "Req"] || false;
            this.tooltip = props.propertyOwner.constructor[props.propertyName + "Tooltip"] || "";
            this.getMinMaxRange(props);
            this.precision = props.precision ? props.precision : (!!props.isPc ? 2 : 0);
            this.isNumberRegexPattern = props.isPc
                ? `^\\d{1,3}${this.precision ? `\\.?\\d{0,${this.precision}}` : ""}$`
                : `^${!!props.allowNegative ? "-?" : ""}\\d{0,${this.max.toString().length}}${this.precision ? `\\.?\\d{0,${this.precision}}` : ""}$`;
            this.isNumberRegex = new RegExp(this.isNumberRegexPattern);
            this.value = props.isPc
                ? this.pcToValue(props.propertyOwner[props.propertyName])
                : props.propertyOwner[props.propertyName];
        }
        componentWillUnmount() {
            this.stopObserving();
        }
        startObserving() {
            if (this.onChangeObserver) {
                this.stopObserving();
            }
            !(0, Environment_1.isProduction)() && console.log(this.props.propertyName, "start observing");
            this.observedObject = this.props.propertyOwner;
            this.onChangeObserver = (0, mobx_1.observe)(this.props.propertyOwner, this.props.propertyName, (change) => {
                !(0, Environment_1.isProduction)() && console.log(this.props.propertyName, "observing change", this.props.propertyOwner[this.props.propertyName]);
                this.componentWillReceiveProps(this.props);
            });
        }
        stopObserving() {
            !(0, Environment_1.isProduction)() && console.log(this.props.propertyName, "stop observing");
            this.onChangeObserver && this.onChangeObserver();
            this.observedObject = undefined;
        }
        getMinMaxRange(props) {
            if (!!props.isPc) {
                this.min = props.min >= 0 && props.min < 1 ? props.min : 0;
                this.max = props.max <= 1 && props.max > 0 ? props.max : 1;
            }
            else {
                this.min = props.min || (!!props.allowNegative ? NumberField_1.MAX_NUMBER * -1 : 0);
                this.max = props.max;
                if (!this.max) {
                    const modelLength = props.propertyOwner.constructor[props.propertyName + "Length"];
                    if (modelLength) {
                        this.max = parseInt(new Array(modelLength).join("9"));
                    }
                    else {
                        this.max = NumberField_1.MAX_NUMBER;
                    }
                }
            }
        }
        componentWillReceiveProps(nextProps) {
            if (nextProps.min !== this.props.min || nextProps.max !== this.props.max) {
                this.getMinMaxRange(nextProps);
                this.valueError = "";
            }
            const rewValRaw = nextProps.propertyOwner[nextProps.propertyName];
            let newValue = rewValRaw;
            if (nextProps.isPc) {
                newValue = this.pcToValue(rewValRaw);
            }
            if (this.value !== newValue) {
                this.value = (0, mobx_1.observable)(newValue);
            }
        }
        pcToValue(fraction) {
            const pc = fraction * 100;
            if (this.precision > 0 && (pc % 1) > 0) {
                return Math.trunc(pc) + parseFloat((pc % 1).toFixed(this.precision));
            }
            return pc;
        }
        handleChange(newValue) {
            const { propertyOwner, propertyName, onChange, isString } = this.props;
            let newValRaw = parseFloat(newValue);
            if (this.props.isPc) {
                newValRaw = newValRaw / 100;
            }
            const isValidForm = (newValue == "" || this.isNumberRegex.test(newValue));
            if (isValidForm) {
                this.value = newValue;
                if (newValRaw >= this.min && newValRaw <= this.max) {
                    this.valueError = null;
                    const newValRawParsed = isString ? newValRaw.toString() : newValRaw;
                    if (onChange) {
                        const oldValRaw = propertyOwner[propertyName];
                        onChange(propertyOwner, propertyName, oldValRaw, newValRawParsed);
                    }
                    else {
                        propertyOwner[propertyName] = newValRawParsed;
                    }
                }
                else {
                    if (this.props.isPc) {
                        this.valueError = `Must be between ${this.min * 100} & ${this.max * 100}`;
                    }
                    else {
                        this.valueError = `Must be between ${this.min} & ${this.max}`;
                    }
                }
            }
        }
        render() {
            if ((0, mobx_1.isObservable)(this.props.propertyOwner)) {
                let objectChanged = this.observedObject == undefined || this.observedObject !== this.props.propertyOwner;
                if (objectChanged) {
                    this.startObserving();
                }
            }
            const { id, disabled, hideLabel, fullWidth, tooltip, style } = this.props;
            const error = this.valueError ? this.valueError : this.props.propertyOwner[this.props.propertyName + "Error"];
            const field = React.createElement(index_1.TextField, { id: id, propertyOwner: this, propertyName: "value", disabled: disabled, required: this.required, hideLabel: hideLabel, fullWidth: fullWidth, tooltip: tooltip || this.tooltip, errorText: error, style: style, onChange: (propertyOwner, propertyName, oldValue, newValue) => this.handleChange.call(this, newValue) });
            return field;
        }
    };
    Object.defineProperty(NumberField, "MAX_NUMBER", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 100000000
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], NumberField.prototype, "value", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], NumberField.prototype, "valueError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], NumberField.prototype, "componentWillReceiveProps", null);
    exports.NumberField = NumberField = NumberField_1 = tslib_1.__decorate([
        mobx_react_1.observer
    ], NumberField);
});
